import { render } from "./PokemonDetail.vue?vue&type=template&id=5dce7abe&scoped=true"
import script from "./PokemonDetail.vue?vue&type=script&lang=js"
export * from "./PokemonDetail.vue?vue&type=script&lang=js"

import "./PokemonDetail.vue?vue&type=style&index=0&id=5dce7abe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dce7abe"]])

export default __exports__